import { Box, Divider, Modal } from "@mui/material";
import { Widget } from "@typeform/embed-react";
import { useContext, useEffect, useState } from "react";
import { UserProgramContext } from "../context/user-program/user-program";
import { TYPEFORM_ANAMNESEBOGEN_ID } from "../constants";
import { setFormFilled } from "../api/user-program";

export const TypeformModal = () => {
  const { program, dispatch, role } = useContext(UserProgramContext);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      role === "patient" &&
      !program?.formsFilled?.includes(TYPEFORM_ANAMNESEBOGEN_ID)
    ) {
      setOpen(true);
    }
  }, [program, role]);

  const onTypeformSubmit = () => {
    setFormFilled({ formID: TYPEFORM_ANAMNESEBOGEN_ID }).then(() => {
      setOpen(false);
      dispatch({
        type: "FORM_FILLED",
        payload: { formId: TYPEFORM_ANAMNESEBOGEN_ID },
      });
    });
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          height: { xs: "100%", md: "75%", lg: "50%" },
          width: { xs: "100%", md: "75%" },
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          pt: 2,
          px: 4,
          pb: 3,
        }}
      >
        <Box mb={2}>
          <Widget
            id="oLfjZqYg"
            onSubmit={onTypeformSubmit}
            style={{ width: "100%", height: "500px" }}
            iframeProps={{ title: "Fragebogen im MMK-Bereich" }}
          />
        </Box>
        <Divider />
      </Box>
    </Modal>
  );
};
